<!-- eslint-disable vue/no-v-html -->
<template>
  <ClientOnly>
    <div class="bg-primary-white p-4 md:p-6 rounded-2xl mt-4">
      <div class="space-y-[10px]">
        <div>
          {{ $t('products.titlePersonalizable1') }}
          <span class="font-bold">{{
            $t('products.titlePersonalizable2')
          }}</span>
        </div>
        <div>
          <div class="mb-[10px]">{{ $t('products.text') }}</div>
          <div
            class="font-['CabinetGrotesk-Variable','Font_Awesome_6_Free'] relative"
          >
            <div class="absolute -top-8 right-0">
              {{ personalizeText.length }} / 20
            </div>
            <FormTextInput
              :error="personalizeTextError"
              :error-message="$t('products.invalidText')"
              name="text"
              full
              :value="personalizeText"
              :max-length="20"
              fullper
              @change="
                (nextValue) => {
                  handleUpdatePersonalizeText(nextValue)
                }
              "
            />
          </div>
        </div>
        <div>
          <nuxt-error-boundary @error="() => {}">
            <Swiper
              :modules="[SwiperEffectCreative, SwiperPagination]"
              :slides-per-view="1"
              :space-between="16"
              :pagination="{
                clickable: true,
                bulletActiveClass: '!bg-gray-40',
                renderBullet: (_index, className) => {
                  return (
                    `<span class='` +
                    className +
                    ` !w-2 !h-2 translate-y-3 !bg-gray-20 !opacity-100'></span>`
                  )
                }
              }"
              :creative-effect="{
                prev: {
                  shadow: false,
                  translate: ['-20%', 0, -1]
                },
                next: {
                  translate: ['100%', 0, 0]
                }
              }"
              class="!pb-7 !overflow-y-visible"
            >
              <SwiperSlide
                v-for="(emojiSet, index) in chunk(
                  emojiOptions,
                  width < 768 ? 10 : 18
                )"
                :key="index"
              >
                <div class="grid grid-cols-5 md:grid-cols-9 gap-y-2 gap-x-1">
                  <div
                    v-for="emoji in emojiSet"
                    :key="emoji.id"
                    class="pt-[100%] border-2 border-primary-white hover:border-primary-tangerine rounded-2xl cursor-pointer relative"
                    @click="(e) => handleAddEmoji(e, emoji.emoji_code)"
                  >
                    <div
                      class="absolute top-0 w-full bg-gray-10 h-full rounded-[15px] flex items-center justify-center select-none border-2 border-primary-white"
                    >
                      <div class="font-['Font_Awesome_6_Free']">
                        <i
                          class="fa-solid"
                          v-html="`${'&'}#x${emoji.emoji_code};`"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </nuxt-error-boundary>
        </div>
        <!-- <div>Select <span class="font-bold">Background Style</span></div>
      <div class="grid grid-cols-8 gap-y-2 gap-x-1">
        <div
          v-for="backgroundStyle in productPersonalizeOptionData?.data.style"
          :key="backgroundStyle.id"
          :class="
            twJoin(
              'h-[56px] border-2 border-primary-white hover:border-primary-tangerine rounded-2xl cursor-pointer',
              '!border-primary-tangerine'
            )
          "
        >
          <div
            class="bg-gray-10 h-full rounded-[15px] flex items-center justify-center border-2 border-primary-white"
          />
        </div>
      </div> -->
        <div>
          {{ $t('products.select') }}
          <span class="font-bold">{{ metadata.textStyle?.name }}</span>
        </div>
        <div class="grid grid-cols-6 md:grid-cols-8 gap-y-2 gap-x-1">
          <div
            v-for="textStyle in orderBy(
              productPersonalizeOptionData?.personalization_template_text_font,
              ['order'],
              'asc'
            )"
            :key="textStyle.id"
            :class="
              twJoin(
                'h-[56px] pt-[100%] border-2 border-primary-white hover:border-primary-tangerine rounded-2xl cursor-pointer relative',
                metadata.textStyle?.name === textStyle.name &&
                  '!border-primary-tangerine'
              )
            "
            @click="
              updateMetadata({
                textStyle: {
                  name: textStyle.name,
                  url: textStyle.font_file_url,
                  id: textStyle.id
                }
              })
            "
          >
            <div
              class="absolute top-0 left-0 bg-gray-10 w-full h-full rounded-[15px] flex items-center justify-center border-2 border-primary-white"
            >
              <span :style="{ fontFamily: textStyle.name }">ABC</span>
            </div>
          </div>
        </div>
        <div>
          {{ $t('products.select') }}
          <span class="font-bold">{{ $t('products.textPosition') }}</span>
        </div>
        <div class="grid grid-cols-6 md:grid-cols-8 gap-y-2 gap-x-1">
          <div
            v-for="(textPosition, index) in orderBy(
              productPersonalizeOptionData?.personalization_template_text_position,
              ['order'],
              'asc'
            )"
            :key="index"
            :class="
              twJoin(
                'h-[56px] pt-[100%] border-2 border-gray-300 hover:border-primary-tangerine rounded-2xl cursor-pointer relative overflow-hidden',
                metadata.textPosition === textPosition.name &&
                  '!border-primary-tangerine'
              )
            "
            @click="
              updateMetadata({
                textPosition: textPosition.name,
                textPositionId: textPosition.id
              })
            "
          >
            <div
              class="absolute top-0 left-0 bg-gray-10 w-full h-full rounded-[15px] flex items-center justify-center border-2 border-primary-white"
            >
              <img
                :src="config.public.mediaUrl + textPosition.thumbnail_image_url"
                alt="font-position-thumbnail"
                class="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        <div>
          {{ $t('products.select') }}
          <span class="font-bold">{{ $t('products.textColors') }}</span>
        </div>
        <div class="grid grid-cols-6 md:grid-cols-8 gap-y-2 gap-x-2">
          <div
            v-for="textColor in orderBy(textColorOptions, ['order'], 'asc')"
            :key="textColor.id"
            :class="
              twJoin(
                'h-[56px] pt-[100%] border-2 border-primary-white hover:border-primary-tangerine rounded-2xl cursor-pointer relative',
                metadata.textColors.colors === textColor.color &&
                  '!border-primary-tangerine'
              )
            "
            @click="
              updateMetadata({
                textColors: {
                  colors: textColor.color,
                  rotation: textColor.rotation,
                  id: textColor.id
                }
              })
            "
          >
            <div
              class="absolute top-0 left-0 bg-gray-10 w-full h-full rounded-[15px] flex items-center justify-center border-2 border-primary-white"
              :style="getStyleColor(textColor.color, textColor.rotation)"
            />
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { chunk, first, forEach, includes, last, map, orderBy } from 'lodash-es'
import { twJoin } from 'tailwind-merge'
import { usePersonalizationStoreV2 } from '~/stores/v2/personalizationV2'
import type { GetProductDetailResponse } from '~/types/apis/v2/getProductDetail'

const config = useRuntimeConfig()
const emits = defineEmits<{
  (
    e: 'loaded',
    personalizationOptionsData: GetProductDetailPersonalizeResponse['data']
  ): void
  (e: 'error'): void
  (e: 'valid'): void
}>()
const route = useRoute()
const { width } = useWindowSize()

const params = computed(() => route.params)
// const query = computed(() => route.query)

const isLoading = ref(true)

const { updateMetadata } = usePersonalizationStoreV2()

const personalizationStore = usePersonalizationStoreV2()
const { metadata } = storeToRefs(personalizationStore)

const slug = computed(() => params.value.slug as string)
const productSlug = computed(() => slug.value?.[0] as string)
const artworkSlug = computed(() => slug.value?.[1] as string)

const personalizeText = ref(metadata.value.personalizeText.raw)
const personalizeTextError = ref(false)

const getStyleColor = (colors: string, rotation: number, text?: boolean) => {
  const parsedColor = colors
  if (parsedColor?.includes(',')) {
    if (text)
      return `background-image: linear-gradient(${rotation}deg, ${parsedColor})`
    return `background: linear-gradient(${rotation}deg, ${parsedColor})`
  } else {
    return 'background-color: ' + parsedColor
  }
}

const getFontName = (url: string) =>
  first(last(url.split('/'))?.split('.')) as string

const fontFormat = {
  ttf: 'truetype',
  otf: 'opentype',
  woff: 'woff',
  woff2: 'woff2'
}

const loadFont = (url: string) => {
  const fontName = getFontName(url)
  const styleId = `font-${fontName}`
  let style = document.getElementById(styleId) as HTMLStyleElement

  if (!style) {
    style = document.createElement('style')
    style.id = styleId

    const fontFileUrl = config.public.mediaUrl + url
    if (fontName) {
      const fontFaceRule = `
          @font-face {
              font-family: '${fontName}';
              src: url('${fontFileUrl}') format('${fontFormat[last(last(url.split('/'))?.split('.')) as keyof typeof fontFormat]}'); /* Adjust format if needed */
              font-weight: normal;
              font-style: normal;
          }
      `
      style.appendChild(document.createTextNode(fontFaceRule))
      document.head.appendChild(style)
      console.log('Font Loaded', fontFileUrl)
    }
  }
}

const { data: productDetailData, execute: refreshProductDetail } =
  await useQuery<GetProductDetailResponse>(
    () =>
      `/v2/storefront/product/${productSlug.value}/${artworkSlug.value}/product-detail`,
    {
      server: false,
      watch: [productSlug, artworkSlug],
      method: 'GET',
      onResponse: async ({ response }) => {
        if (response.status == 200) {
          isLoading.value = false
          emits('loaded', response._data.data)
          if (
            !includes(
              map(
                response._data.data?.personalization_template
                  ?.personalization_template_text_font,
                (item) => item.name
              ),
              metadata.value.textStyle
            )
          ) {
            updateMetadata({
              textStyle: {
                name: response._data.data?.personalization_template
                  ?.personalization_template_text_font?.[0]?.name,
                url: response._data.data?.personalization_template
                  ?.personalization_template_text_font?.[0]?.font_file_url,
                id: response._data.data?.personalization_template
                  ?.personalization_template_text_font?.[0]?.id
              }
            })
            forEach(
              response._data.data?.personalization_template
                ?.personalization_template_text_font,
              (item) => loadFont(item?.font_file_url)
            )
          }
          if (
            !includes(
              map(
                response._data.data?.personalization_template
                  ?.personalization_template_text_position,
                (item) => item.position_name
              ),
              metadata.value.textPosition
            )
          ) {
            updateMetadata({
              textPosition:
                response._data.data?.personalization_template
                  ?.personalization_template_text_position?.[1].name,
              textPositionId:
                response._data.data?.personalization_template
                  ?.personalization_template_text_position?.[1].id
            })
          }
          if (
            !includes(
              map(
                response._data.data?.personalization_template
                  ?.personalization_template_text_color,
                (item) => item.color
              ),
              metadata.value.textColors.colors
            )
          ) {
            updateMetadata({
              textColors: {
                colors:
                  response._data.data?.personalization_template
                    ?.personalization_template_text_color?.[0].color,
                rotation:
                  response._data.data?.personalization_template
                    ?.personalization_template_text_color?.[0].rotation,
                id: response._data.data?.personalization_template
                  ?.personalization_template_text_color?.[0].id
              }
            })
          }
        }
      }
    }
  )

const productPersonalizeOptionData = computed(
  () => productDetailData.value?.data?.personalization_template
)

const textColorOptions = computed(() => {
  const newArr =
    productPersonalizeOptionData?.value?.personalization_template_text_color
      ?.slice()
      .reverse()
  return newArr
})

const emojiOptions = computed(() => {
  const newArr = orderBy(
    productPersonalizeOptionData?.value?.personalization_template_emoji,
    ['order'],
    'asc'
  )
  return newArr
})
const handleAddEmoji = (e: Event, _emojiCode: string) => {
  if (personalizeText.value.length === 20) return
  const innerText = (e.target as HTMLDivElement).innerText
  personalizeText.value += innerText
}

const handleUpdatePersonalizeText = (text: string) => {
  const maxLength = 20
  if (text.length > maxLength) return
  const cleanedText = text.replace(
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{23F0}\u{23F3}\u{24C2}\u{1F004}-\u{1F0CF}\u{2B06}\u{2194}\u{2195}\u{23F0}\u{23F3}]+/gu,
    ''
  )
  const specialCharRegex =
    /[^\w\s\u0E00-\u0E7F[]{}#%^\*+=_\|~<>$€¥•.,?!’-\/:;()฿&@”]/
  if (specialCharRegex.test(cleanedText)) {
    emits('error')
    personalizeTextError.value = true
  } else {
    personalizeTextError.value = false
    emits('valid')
  }
  personalizeText.value = cleanedText
}

watch(personalizeText, (nextValue) => {
  updateMetadata({
    personalizeText: {
      raw: nextValue
    }
  })
})

onMounted(() => {
  refreshProductDetail()
})
</script>
